module.exports = __webpack_public_path__ + "img/imgHome01.97147557.png";